import React from 'react';

/**
 * Componente: Resultados de Día de Picnic (Pantalla Gigante)
 * Se muestra cuando el Admin detiene el juego y declara un ganador.
 */
const Picnic = ({ matchResults, isActiveWomensMode }) => {
    // Extraemos la información que nos mandó el C# en el payload "data"
    const { winner, scoreLucho, scoreTunita } = matchResults || {};

    // Evaluamos los textos y colores dinámicamente según quién ganó
    let winnerTitle = "¡EMPATE!";
    let winnerColor = "#facc15"; // Amarillo por defecto
    let winnerImage = null;

    if (winner === 'lucho') {
        winnerTitle = "¡GANÓ LUCHO!";
        winnerColor = "#3b82f6"; // Azul para Lucho
        winnerImage = '/img/games/runtogoal/luchito-caricatura.png';
    } else if (winner === 'tunita') {
        winnerTitle = "¡GANÓ TUNITA!";
        winnerColor = "#ec4899"; // Rosa/Morado para Tunita
        winnerImage = '/img/games/runtogoal/tunita-caricatura.png';
    }

    return (
        <>
            {/* FONDO ESTANDARIZADO */}
            <div className='FrontPage--Riddle__Screen__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                ) : (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                )} */}

                <img src='/img/games/picnic/background.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
            </div>

            {/* CONTENIDO PRINCIPAL: LOS RESULTADOS */}
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ position: 'absolute', inset: 0, zIndex: 10, textAlign: 'center', color: 'white' }}>
                
                <div className="p-5 position-relative" style={{ 
                    //backgroundColor: 'rgba(255, 255, 255, 0.95)', 
                    //borderRadius: '40px', 
                    //border: `10px solid ${winnerColor}`, 
                    //color: '#1f2937', 
                    //boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
                    //minWidth: '60%'
                }}>
                    {/* <h2 style={{ fontSize: '1em', fontWeight: 'bold', margin: '0' }}>¡TIEMPO AGOTADO!</h2> */}
                    <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />
                    
                    {/* TÍTULO DEL GANADOR */}
                    <div style={{ fontSize: '7.5em', fontWeight: '900', color: '#d6352d', textTransform: 'uppercase', textShadow: '4px 4px 0px rgba(0,0,0,0.1)', lineHeight: '1.1', margin: '0' }}>
                        {winnerTitle}
                    </div>

                    {/* IMAGEN DEL GANADOR (Opcional) */}
                    {winnerImage && (
                        <>
                            <img src={winnerImage} alt={winner} style={{ height: '350px', objectFit: 'contain', filter: 'drop-shadow(0 10px 10px rgba(0,0,0,0.3))' }} />
                        </>
                    )}
                    
                    {/* MARCADOR FINAL COMPARATIVO */}
                    <div className="d-flex justify-content-around mt-1">
                        <div className="text-center" style={{ flex: 1 }}>
                            <p style={{ fontSize: '3em', margin: 0, fontWeight: 'bold', color: '#3b82f6', textShadow: '4px 4px 0px rgba(0,0,0,0.1)' }}>LUCHO</p>
                            <p style={{ fontSize: '6em', margin: 0, fontWeight: '900', color: '#3b82f6' }}>{scoreLucho || 0}</p>
                        </div>
                        <div style={{ width: '3px', backgroundColor: '#000', margin: '0 2rem' }}></div>
                        <div className="text-center" style={{ flex: 1 }}>
                            <p style={{ fontSize: '3em', margin: 0, fontWeight: 'bold', color: '#ec4899', textShadow: '4px 4px 0px rgba(0,0,0,0.1)' }}>TUNITA</p>
                            <p style={{ fontSize: '6em', margin: 0, fontWeight: '900', color: '#ec4899' }}>{scoreTunita || 0}</p>
                        </div>
                    </div>

                    {/* DECORACIÓN ESTILO CONFETI */}
                    {/* <div style={{ position: 'absolute', top: '50px', left: '-100px', fontSize: '6em' }}>🎉</div>
                    <div style={{ position: 'absolute', top: '50px', right: '-100px', fontSize: '6em' }}>🎊</div> */}
                </div>

            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits' style={{ color: '#000' }}>
                Hecho con ♥ por Interaktia | 2026
            </footer>
        </>
    );
};

export { Picnic };